import { BlobServiceClient } from "@azure/storage-blob";
import { formatDate } from "./helper";
import httpService from "./httpService";
// import { blobStorageUrl } from "../config/config.json";
import { notifier } from "@tintelligence/components";

const blobStorageUrl = process.env.REACT_APP_BLOB_STORAGE_URL;

function getSasParamValue(sasToken, paramName) {
  const query = new URLSearchParams(sasToken.startsWith("?") ? sasToken : `?${sasToken}`);
  return query.get(paramName);
}

const isBlobSasTokenValid = async (blobSasToken) => {
  try {
    const expiryParam = getSasParamValue(blobSasToken, "se");
    if (!expiryParam) {
      console.log("SAS Expiry expiryParam:", expiryParam);
      return false;
      //throw new Error("No expiry time found in SAS token");
    }

    const sasExpiryDate1 = new Date(decodeURIComponent(expiryParam));
    console.log("SAS Expiry:", sasExpiryDate1, sasExpiryDate1.toISOString());


    const currDate = new Date();
    // const sasExpiryDate = new Date(
    //   decodeURIComponent(
    //     blobSasToken.substring(
    //       blobSasToken.indexOf("&se") + 4,
    //       blobSasToken.indexOf("&srt")
    //     )
    //   )
    // );
    // console.log("Sas expiry date", sasExpiryDate);
    // console.log("Current date", currDate);
    // console.log("Sas token", (sasExpiryDate - currDate ));

    if (sasExpiryDate1 - currDate < 1800000) return false;
    new BlobServiceClient(
      `${blobStorageUrl}${blobSasToken}`
    ).getContainerClient("digitalsolutions-storage");
    return true;
  } catch (e) {
    console.log("Sas token expired", e);
    return false;
  }
};

const getValidBlobSasUrl = async (forceRefresh = false) => {
  const blobSasToken = await getValidBlobSasToken(forceRefresh);
  return `${blobStorageUrl}${blobSasToken}`;
};

const getContainerClient = async (containerName, forceRefresh = false) => {
  const blobSasUrl = await getValidBlobSasUrl(forceRefresh);
  const blobServiceClient = new BlobServiceClient(blobSasUrl);
  return blobServiceClient.getContainerClient(containerName?.toLowerCase());
};

export const uploadFileToStorage = async (
  file,
  containerName,
  folderName,
  onUploadProgress = () => { },
  fileName
) => {
  try {
    const fileSize = file.size;
    const containerClient = await getContainerClient(containerName);
    const blockBlobClient = containerClient.getBlockBlobClient(
      `${folderName}/${fileName || file.name}`
    );
    return blockBlobClient.uploadBrowserData(file, {
      onProgress: ({ loadedBytes }) => {
        onUploadProgress({ percent: (loadedBytes / fileSize) * 100 });
      },
    });
  } catch (e) {
    console.log("e", e);
    notifier.error("Upload to cloud failed!!");
    return false;
  }
};

export const getServicePacksForAMachineSeriesFromStorage = async (
  containerName,
  folderName
) => {
  const containerClient = await getContainerClient(containerName);
  const servicePacks = [];
  let iter = containerClient.listBlobsByHierarchy("/", {
    prefix: `${folderName}/`,
    includeMetadata: true,
  });
  for await (let item of iter) {
    let { name, kind, properties } = item;
    if (kind === "blob") {
      const servicePack = name.substring(name.lastIndexOf("/") + 1);
      let isPublished = item.metadata ? item.metadata.isPublished : false;
      let previousRequiredVersion2 = item.previousRequiredVersion ? item.metadata.previousRequiredVersion : ""
      const servicePackInfo = {
        servicePack,
        isPublished: isPublished,
        previousRequiredVersion: previousRequiredVersion2,
        uploadDate: properties.createdOn,
        publishDate: isPublished ? properties.lastModified : null,
      };
      servicePacks.push(servicePackInfo);
    }
  }
  return servicePacks
    .sort((p1, p2) => p2.uploadDate - p1.uploadDate)
    .map((pack) => ({
      ...pack,
      //uploadDate: formatDate(pack.uploadDate, "DD/MM/YYYY"),
      //publishDate: pack.publishDate && formatDate(pack.publishDate, "DD/MM/YYYY"),
    }));
};

export const updateMetadataPropertyForABlob = async (
  containerName,
  folderName,
  fileName,
  previousRequiredVersion,
  messages
) => {
  try {
    const containerClient = await getContainerClient(containerName);
    const blockBlobClient = containerClient.getBlockBlobClient(
      `${folderName}/${fileName}`
    );
    blockBlobClient.setMetadata({ previousRequiredVersion });
  } catch (e) {
    notifier.warn(
      messages.metaDataPropertyErr + previousRequiredVersion
    );
  }
};

export const createFolder = async (
  containerName,
  parentFolderPath,
  folderName,
  metaInfoText = "Dummy file for Folder meta"
) => {
  try {
    const containerClient = await getContainerClient(containerName);
    const file = new File([metaInfoText], `metaInfo.txt`, {
      type: "text/plain",
      lastModified: new Date(),
    });
    const blockBlobClient = containerClient.getBlockBlobClient(
      `${parentFolderPath}/${folderName}/${file.name}`
    );
    await blockBlobClient.uploadBrowserData(file);
    return true;
  } catch (e) {
    notifier.warn(`Error occured while creating folder` + parentFolderPath);
    return false;
  }
};

export const getFilesIteratorForAFolder = async (containerName, folderPath, forceRefresh = false) => {
  const containerClient = await getContainerClient(containerName, forceRefresh);
  return containerClient.listBlobsByHierarchy("/", {
    prefix: folderPath,
    includeMetadata: true,
  });
};

export const getSubFoldersIteratorForAFolder = async (
  containerName,
  parentFolder
) => {
  const containerClient = await getContainerClient(containerName);
  return containerClient.listBlobsByHierarchy("/", {
    prefix: parentFolder,
  });
};

export const deleteFolder = async (containerName, parentFolder, folderName) => {
  try {
    const containerClient = await getContainerClient(containerName);
    let iter = containerClient.listBlobsByHierarchy("/", {
      prefix: `${parentFolder}/${folderName}/`,
    });
    for await (const { name } of iter) {
      containerClient.deleteBlob(name);
    }
    //notifier.success(`Folder - ${folderName} deleted successfully`);
    return true;
  } catch (e) {
    notifier.warn(`Error occured while deleting folder ${folderName}`);
    return false;
  }
};

export const deleteFile = async (containerName, fileName, filePath) => {
  try {
    const containerClient = await getContainerClient(containerName);
    await containerClient.deleteBlob(filePath);
    notifier.success(`File - ${fileName} deleted successfully`);
    return true;
  } catch (e) {
    notifier.warn(`Error occured while deleting file ${fileName}`);
    return false;
  }
};

export const clearBlobSasToken = () => {
  localStorage.removeItem("blobSasToken");
};

export const getValidBlobSasToken = async (forceRefresh = false) => {
  let blobSasToken = forceRefresh ? null : localStorage.getItem("blobSasToken");
  const isTokenValid = !forceRefresh && await isBlobSasTokenValid(blobSasToken);
  if (!isTokenValid) {
    const { data } = await httpService.get("/spm/api/blobstorage");
    blobSasToken = data.message;
    localStorage.setItem("blobSasToken", blobSasToken);
  }
  return blobSasToken;
};


export const getDownloadUrlForAFile = async (containerName, folderName, fileName) => {
  const sasToken = await getValidBlobSasToken();
  const url = `${blobStorageUrl}${containerName}/${folderName}/${fileName}${sasToken}`;
  return url;
};
export const getDownloadUrlForAFileWithoutSAS = async (containerName, folderName, fileName) => {
  const url = `${blobStorageUrl}${containerName}/${folderName}/${fileName}`;
  return url;
};
export const getDownloadUrlForALogs = async (containerName, fileName) => {
  const sasToken = await getValidBlobSasToken();
  const url = `${blobStorageUrl}${containerName}/${fileName}${sasToken}`;
  return url;
};

export const fileDownloadHandler = (url, name = "") => {
  if (url) {
    fetch(url).then(function (t) {
      return t.blob().then((b) => {
        var a = document.createElement("a");
        a.href = URL.createObjectURL(b);
        a.setAttribute("download", name);
        a.click();
      });
    });
  }
};

export const setMetadataPropertiesForABlob = async (
  containerName,
  folderName,
  fileName,
  properties
) => {
  try {
    const containerClient = await getContainerClient(containerName);
    const blockBlobClient = containerClient.getBlockBlobClient(
      `${folderName}/${fileName}`
    );
    await blockBlobClient.setMetadata({ ...properties });
  } catch (e) {
    console.log(e);
  }
};

export const getFolderMetadata = async (containerName, folderPath) => {
  try {
    const containerClient = await getContainerClient(containerName);
    let iter = await containerClient.listBlobsByHierarchy("/", {
      prefix: `${folderPath}metaInfo.txt`,
      includeMetadata: true,
    });
    const folderMetadata = {};
    for await (const { name, metadata } of iter) {
      folderMetadata.filesCount = Number(metadata.filescount || 0);
      folderMetadata.folderSize = Number(metadata.foldersize || 0);
      folderMetadata.folderDisplayName = metadata.folderdisplayname;
      folderMetadata.lastModified = metadata.lastmodified;
      break;
    }
    return folderMetadata;
  } catch (e) {
    console.log(e);
    return {};
  }
};
